import React, { useState } from "react";
import {
    Container,
    Typography,
    useTheme,
    LinearProgress,
    Button,
    Tooltip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    CircularProgress,
    IconButton,
    Box,
    colors,
    TextField,
    MenuItem,
} from "@material-ui/core";


import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";

import { useUnitsBySerialNumber } from "../../../../testCommunication/common/testQueries";
import { useResults, useTestPermissions } from "../../../projectQueries";
import { formatDate } from "../../../../common/formatDate";
import { useDispositionsByName, useUnitsDispositions } from "../../../../common/services/dispositionServices";
import { TravelerContainer } from "../../../../common/traveler/TravelerContainer";
import { TravelerMasterContainer } from "../../../../common/traveler/TravelerMasterContainer";
import { TravelerMasterRow } from "../../../../common/traveler/TravelerMasterRow";
import { TravelerNotesContainer } from "../../../../common/traveler/TravelerNotesContainer";
import { TravelerGroupHeader } from "../../../../common/traveler/TravelerGroupHeader";
import { useTestSequenceDefinitionDetails } from "../../../testSequenceDefinitionQueries";

const useStyles = makeStyles(() => ({
    baseBorder: {
        borderStyle: "solid",
        borderWidth: "1px",
    },

    nobaseBorder: {
        borderStyle: "none",
        borderWidth: "0px",
    },

    selectedBoreder: {
        borderStyle: "solid",
        borderWidth: "4px",
        borderColor: colors.green[500],
    },
}));

export const TsdTravelerComponent = ({ tsdData,id, selectedProcedure }: any) => {
    const classes = useStyles();
    const theme = useTheme();



    const addTime = (dateString: any, duration: number) => {
        const oldDate = new Date(dateString);
        const newDate = new Date(oldDate.getTime() + duration * 60000);
        return formatDate(newDate.toString());
    };

    return (
        <Container>
            {
            

                 (
                    <>


                        <TravelerContainer>
                            <TravelerMasterContainer>
                                <TravelerMasterRow header="Name" data={"Mechanical Stress Sequence"} />

                                <TravelerMasterRow
                                    header="Test Sequence Definition Name"
                                    data={"Mechanical Stress Sequence"}
                                />  
                                <TravelerMasterRow header="Description" data={"N/A"} />
                            </TravelerMasterContainer>
                            <TravelerNotesContainer />

                            <TravelerGroupHeader header="Procedure"  size={2}/>
                            <TravelerGroupHeader header="Operator" size={2}/>
                            <TravelerGroupHeader header="Test Date" size={2}/>
                            <TravelerGroupHeader header="Disposition" size={2}/>
                            <TravelerGroupHeader header="Reviewer" size={2}/>
                           <TravelerGroupHeader header="Review Date" size={2}/>

                          </TravelerContainer>
                        
                        <Grid container direction="row">
                       

                            {tsdData?.grouped_results.map((leg: any) => (
                                <Grid container direction="row"  className={leg.name===selectedProcedure?classes.selectedBoreder:classes.nobaseBorder}>

                                    <React.Fragment key={leg.id}>
                                    
                                    <Grid
                                        item
                                        xs={2}
                                        className={classes.baseBorder}
                                        style={{ backgroundColor: "yellow" }}
                                    >
                                        <Typography
                                            variant="body2"
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {leg.linear_execution_group}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={10}
                                        className={classes.baseBorder}
                                        style={{ backgroundColor: "#eeeeee" }}
                                    >
                                        <Typography
                                            variant="body2"
                                            align="center"
                                            style={{ fontWeight: "bold" }}
                                        >
                                            {leg.name}
                                        </Typography>
                                    </Grid>

                                    {leg.procedure_results?.map((procedure: any) => (

                                        <React.Fragment key={procedure.id} >
                                            {procedure.final_result ? <Grid item xs={2} className={classes.baseBorder} style={{ backgroundColor: 'lightblue' }}>
                                                {procedure.completion_date && procedure.visualizer
                                                    ? tsdData ? procedure.disposition_name : null
                                                    : procedure.procedure_definition_name}
                                            </Grid> : <Grid item xs={2} className={classes.baseBorder} >
                                                {procedure.completion_date && procedure.visualizer
                                                    ? tsdData ? procedure.disposition_name : null
                                                    : procedure.procedure_definition_name}
                                            </Grid>}

                                            <Grid item xs={2} className={classes.baseBorder}>
                                                <Typography variant="body2" align="center">
                                                    {procedure.username ? (
                                                        <Typography variant="body2" align="center">
                                                            {procedure.username}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ color: "grey" }}
                                                        >
                                                            N/A
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={2} className={classes.baseBorder}>
                                                <Typography variant="body2" align="center">
                                                    {procedure.completion_date ? (
                                                        <Typography variant="body2" align="center">
                                                            {formatDate(procedure.completion_date)}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ color: "grey" }}
                                                        >
                                                            N/A
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Grid>

                                            <Grid item xs={2} className={classes.baseBorder}>
                                                <Typography variant="body2" align="center">
                                                    {procedure.disposition_name ? (
                                                        <Typography variant="body2" align="center">
                                                            {procedure.disposition_name}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ color: "grey" }}
                                                        >
                                                            N/A
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} className={classes.baseBorder}>
                                                <Typography variant="body2" align="center">
                                                    {procedure.reviewed_by_user ? (
                                                        <Typography variant="body2" align="center">
                                                            {procedure.reviewed_by_user}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ color: "grey" }}
                                                        >
                                                            N/A
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={2} className={classes.baseBorder}>
                                                <Typography variant="body2" align="center">
                                                    {procedure.review_datetime ? (
                                                        <Typography variant="body2" align="center">
                                                            {formatDate(procedure.review_datetime)}
                                                        </Typography>
                                                    ) : (
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ color: "grey" }}
                                                        >
                                                            N/A
                                                        </Typography>
                                                    )}
                                                </Typography>
                                            </Grid>
                                            {procedure.visualizer === "stress" &&
                                                procedure.start_datetime !== null ? (
                                                <>
                                                    <Grid
                                                        item
                                                        xs={2}
                                                        className={classes.baseBorder}
                                                        style={{ backgroundColor: "#eeeeee" }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {"Stressor Data"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={2}
                                                        className={classes.baseBorder}
                                                        style={{ backgroundColor: "#eeeeee" }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {`Start Date:`}
                                                        </Typography>
                                                        <Typography variant="body2" align="center">
                                                            {`${formatDate(procedure.start_datetime)}`}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={2}
                                                        className={classes.baseBorder}
                                                        style={{ backgroundColor: "#eeeeee" }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {"Entered By:"}
                                                        </Typography>
                                                        <Typography variant="body2" align="center">
                                                            {procedure.username}
                                                        </Typography>
                                                    </Grid>
                                                    {procedure.end_datetime !== null ? (
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            className={classes.baseBorder}
                                                            style={{ backgroundColor: "#eeeeee" }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                align="center"
                                                                style={{ fontWeight: "bold" }}
                                                            >
                                                                {"Exit Date"}
                                                            </Typography>
                                                            <Typography variant="body2" align="center">
                                                                {formatDate(procedure.end_datetime)}
                                                            </Typography>
                                                        </Grid>
                                                    ) : (
                                                        <Grid
                                                            item
                                                            xs={2}
                                                            className={classes.baseBorder}
                                                            style={{ backgroundColor: "#eeeeee" }}
                                                        >
                                                            <Typography
                                                                variant="body2"
                                                                align="center"
                                                                style={{ fontWeight: "bold" }}
                                                            >
                                                                {"Estimated Exit Date:"}
                                                            </Typography>
                                                            <Typography variant="body2" align="center">
                                                                {addTime(
                                                                    procedure.start_datetime,
                                                                    procedure.duration
                                                                )}
                                                            </Typography>
                                                        </Grid>
                                                    )}
                                                    <Grid
                                                        item
                                                        xs={2}
                                                        className={classes.baseBorder}
                                                        style={{ backgroundColor: "#eeeeee" }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {"Exit User"}
                                                        </Typography>
                                                        <Typography variant="body2" align="center">
                                                            {procedure.exit_user
                                                                ? procedure.exit_user
                                                                : "N/A"}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid
                                                        item
                                                        xs={2}
                                                        className={classes.baseBorder}
                                                        style={{ backgroundColor: "#eeeeee" }}
                                                    >
                                                        <Typography
                                                            variant="body2"
                                                            align="center"
                                                            style={{ fontWeight: "bold" }}
                                                        >
                                                            {" "}
                                                        </Typography>
                                                    </Grid>
                                                </>
                                            ) : null}
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                               </Grid>

                            ))}
                        </Grid>
                    </>
                )
            }

        </Container>


    );
};



{/*  <TravelerContainer>
                    <TravelerMasterContainer>
                        <TravelerMasterRow header="Name" data={data?.name} />
                        <TravelerMasterRow
                            header="Test Sequence Definition Name"
                            data={data?.test_sequence_definition_name}
                        />
                        <TravelerMasterRow header="Description" data={data?.description} />
                    </TravelerMasterContainer>
                    <TravelerNotesContainer />
                    <TravelerGroupHeader header="Procedure" size={2} />
                    <TravelerGroupHeader header="Operator" size={2} />
                    <TravelerGroupHeader header="Test Date" size={2} />
                    <TravelerGroupHeader header="Disposition" size={2} />
                    <TravelerGroupHeader header="Reviewer" size={2} />
                    <TravelerGroupHeader header="Review Date" size={2} />

                    {data?.grouped_results.map((groupedResult: any) => (
                        <TravelerGroup data={groupedResult} permissions={permissions} />
                    ))}
                </TravelerContainer> */}